module.exports = __webpack_public_path__ + "static/media/img36.a5768129.jpg";